



































	//import { tlLogErrorTEST, testMetody, testTridy } from "../../../../../../../TL.ISDISP/src/TL.Ivy.MGMT.COR.VUE/TestConsole";
	import { Component } from "../../../Infrastructure/CorBase/CoreBase";
	import TenantListBase from "./TenantListBase";
	 
	@Component
	export default class TenantList extends TenantListBase {
	

		created() {
			super.initializeRights('COR_Tenant_Create', 'COR_Tenant_Delete', 'COR_Tenant_Read', 'COR_Tenant_Update');	
			super.created();
			super.setDetailName('TenantDetail');	
		};	

		tenantId = 0;
        deleteClickFirst(elementId: any) {
            this.tenantId = elementId;
            this.showAlertModalById("alertModalIdToDeleteFirst");
        }

        confirmDeleteClick() {
            this.showAlertModalById("alertModalIdToConfirmDelete");
        }

		deleteClickDo() {
          this.deleteObjectBase(this.tenantId);
		}
	
		loadFilters(value: any) { super.loadFilters(value); };
		createNewClick(elementId: any) { super.createNewClick(elementId); }
		detailClick(elementId: any) { super.detailClick(elementId); };
		deleteClick(elementId: any) {	super.deleteClick(elementId);
		}

	};
